import { makeStyles } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";

export const useFeedbackStyle = makeStyles({
    root: {
        paddingLeft: "20px",
        paddingRight: "20px",
        marginBottom: "10px"
    },
    inputField: {
        marginTop: "12px"
    },
    categoryOption: {
        display: "flex",
        alignItems: "center",
        columnGap: themeTokens.spacingHorizontalS
    },
    commentTextArea: {
        minHeight: "120px",
        maxHeight: "80vh",
        overflowY: "auto"
    },
    buttons: {
        paddingTop: "18px"
    },
    submitButton: {
        marginRight: "10px",
        width: "130px"
    },
    cancelButton: {
        width: "130px"
    }
});
